import * as React from 'react';
import {
	ChipField,
	Datagrid,
	ImageField,
	ListProps,
	ReferenceArrayField,
	SingleFieldList,
	TextField,
	UrlField
} from 'react-admin';
import './DynamicCardDatagrid.scss';
import { TranslateField } from '../components/TranslateField';

export const DynamicCardDatagrid = (props: ListProps): React.ReactElement => {
	return (
		<Datagrid rowClick="edit" className="dynamic-cards-table" optimized
		          hasBulkActions={true}
		          rowStyle={(row: any) => ({ borderRightColor: row._readAt ? '#49d18c' : '#bbbbbb' })}>
			<TextField source="id" label="#"/>
			<ImageField source="imageUrl" label="IMAGE"/>
			<TextField source="name" label="NAME"/>
			<UrlField source="link" label="LINK"/>
			<ReferenceArrayField source="tagsIds" reference="tags" label="TAGS">
				<SingleFieldList>
					<ChipField label="TAGS" source="title"/>
				</SingleFieldList>
			</ReferenceArrayField>
			<TranslateField source="language" label="LANGUAGE"/>
		</Datagrid>
	);
};
